import React from 'react';
import { Icon } from 'antd';

interface IProps {
  smallMapsUrl: string;
  largeMapsUrl: string;
  coordinates: string;
}

interface IState {
  isZoomed: boolean;
}

class MapImage extends React.PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      isZoomed: false,
    }
  }

  toggleZoomed = () => {
    this.setState({ isZoomed: !this.state.isZoomed })
  }

  render() {
    const { largeMapsUrl, smallMapsUrl, coordinates } = this.props;
    const style = this.state.isZoomed ? 'venue-maps-large' : 'venue-maps-small';
    const imageUrl = this.state.isZoomed ? largeMapsUrl : smallMapsUrl;
    const redirectUrl = `https://www.google.com/maps?q=${ coordinates }`;

    return (
      <div>
        <img alt='Karta till eventlokal' className={ style } src={ imageUrl } onClick={ this.toggleZoomed } />
        <a className='venue-maps-link' href={ redirectUrl } target='_blank'>Google Maps <Icon type='arrow-right' /></a>
      </div>
    );
  }
}

export default MapImage;


// WEBPACK FOOTER //
// ./src/pages/EventDetailPage/EventVenueModal/MapImage.tsx